module.exports = "/_next/static/images/delivery_3-2412a2ebaeb7425d6ff8b0558aef8489.png";